var React = require('react');

function Download (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M47.8 60H12.2C5.5 60 0 54.5 0 47.8v-3.6a1.54 1.54 0 0 1 1.5-1.5c.8 0 1.5.7 1.5 1.6v3.6c0 5.1 4.1 9.2 9.2 9.2h35.6c5.1 0 9.2-4.1 9.2-9.2v-3.6a1.54 1.54 0 0 1 1.5-1.5 1.54 1.54 0 0 1 1.5 1.5v3.6C60 54.5 54.5 60 47.8 60zM30 45.7h0 0c-.2 0-.4 0-.5-.1-.2-.1-.3-.2-.5-.3h0 0 0L14.7 31.1c-.6-.6-.6-1.5 0-2.1s1.5-.6 2.1 0l11.7 11.7V1.5A1.54 1.54 0 0 1 30 0a1.54 1.54 0 0 1 1.5 1.5v39.2L43.2 29c.6-.6 1.5-.6 2.1 0s.6 1.5 0 2.1L31.1 45.3h0 0 0 0c-.1.1-.3.2-.5.3s-.4.1-.6.1h0 0 0z"}));
}

Download.defaultProps = {"baseProfile":"tiny","viewBox":"0 0 60 60","overflow":"visible"};

module.exports = Download;

Download.default = Download;
